
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { User } from "@/graph/servicecloud/users";
import graph from "@/graph";
import { UrlShorten } from "@/graph/servicecloud/urlshortener";
import { servicecloudUrlShortenerVariantsResponseEntry } from "@/graph/servicecloud/urlshortener/types/variants";

@Component
export default class UrlShortenerEdit extends Vue
{
	@Prop({ default: undefined }) readonly entrydata: UrlShorten | undefined;
	@Prop({ default: undefined }) readonly pathdata: string | undefined;
	// @Prop(String) readonly userkey: string | undefined;
	// @Prop({ default: true }) readonly visible!: boolean;

	currentKey = "";

	loading = false;
	userData: User | null = null;
	permissions: string[] = [];
	showAllPermissions = false;
	saveButtonLoading = false;
	saveButtonText = "Save";
	path = "";
	hasVariants = false;
	loadingVariants = false;
	variantsList: servicecloudUrlShortenerVariantsResponseEntry[] = [];
	variantsAmount = 0;

	async save()
	{
		console.log("UrlShortenerEdit save", "userData", this.userData);

		// this.saveButtonLoading = true;
		// this.saveButtonText = "Saving ...";

		// if(this.userData)
		// {
		// 	const result = await graph.servicecloud.users.updateUser(
		// 		this.userData.name,
		// 		this.userData.key,
		// 		this.userData.secret,
		// 		this.userData.permission ?? [],
		// 		this.userData.settings ?? [],
		// 		this.userData.salesOrganisation
		// 	);

		// 	console.log("UrlShortenerEdit save", "saveresult", result);
		// }

		// this.saveButtonLoading = false;
		// this.saveButtonText = "Save";
	}

	async loadData()
	{
		// console.log("UrlShortenerEdit::loadData", "currentKey:", this.userkey);
		
		// this.currentKey = this.userkey ?? "";
		// this.loading = true;
		// const result = await graph.servicecloud.users.get(this.userkey ?? "");
		// this.permissions = await graph.servicecloud.users.getAccessPermissions();
		
		// if(result.length > 0)
		// {
		// 	const user = result.pop();

		// 	if(user)
		// 	{
		// 		this.userData = user;
		// 	}
		// }

		// this.loading = false;
	}

	async loadVariants()
	{
		if(!this.hasVariants)
		{
			return;
		}

		this.loadingVariants = true;
		this.variantsList = [];

		const variantsList = await graph.servicecloud.urlshortener.listVariants(this.path);

		if(variantsList === null)
		{
			this.loadingVariants = false;
			return;
		}

		this.variantsAmount = variantsList.amount;
		this.variantsList = variantsList.variants;

		this.loadingVariants = false;
	}

	updated()
	{
		console.log("UrlShortenerEdit updated");

		if(this.pathdata !== this.path)
		{
			this.path = this.pathdata ?? "";
			this.hasVariants = this.entrydata?.hasVariants ?? false;
			this.loadVariants();
		}
	}

	mounted()
	{
		console.log("UrlShortenerEdit mounted");

		if(this.pathdata !== this.path)
		{
			this.path = this.pathdata ?? "";
			this.hasVariants = this.entrydata?.hasVariants ?? false;
			this.loadVariants();
		}

		// if(this.visible == true && this.userkey !== "" && this.userkey !== this.currentKey)
		// {
		// 	await this.loadData();
		// }
	}
	
}
